import React from "react"
import PropTypes from "prop-types"
import { Alert, List, Typography, Space, Row, Col } from "antd"

const LABEL_TITLE = "Incomplete Profile"
const LABEL_RESOLVE = "Resolve"


const InvestmentErrors = ({
  title = LABEL_TITLE,
  errors = [],
  onResolve = undefined,
  isFunded,
}) => {
  const dataSource = errors.map((text, key) => ({ key, text }))
  const hasErrors = dataSource.length > 0

  if (!hasErrors) {
    return null
  }

  if (isFunded) {
    return null
  }

  const renderItem = item =>
    <List.Item style={{ padding: "2px 0px 2px 0px", border: "none" }}>
      <Space>
        <Typography.Text strong>&bull;</Typography.Text>
        <Typography.Text>{item.text}</Typography.Text>
      </Space>
    </List.Item>

  const description = (
    <Row>
      <Col flex="auto">
        <List
          size="small"
          gutter={0}
          itemLayout="vertical"
          dataSource={dataSource}
          renderItem={renderItem}
        />
      </Col>
      <Col>
        <Typography.Link onClick={onResolve}>
          {LABEL_RESOLVE}
        </Typography.Link>
      </Col>
    </Row>
  )

  return (
    <Alert
      type="error"
      style={{ padding: "14px 18px" }}
      message={title}
      description={description}
    />
  )
}

InvestmentErrors.propTypes = {
  title: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  isFunded: PropTypes.bool.isRequired,
  onResolve: PropTypes.func,
}

export default InvestmentErrors
